import { useComponentTranslation } from '@core/i18n'

import { ToastCard } from '../toast-card'

export const ErrorFallback = () => {
  const t = useComponentTranslation('ErrorBoundary')

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  const resetPage = () => window.location.reload(true)

  return (
    <ToastCard
      title={t('Something went wrong')}
      variant="error"
      onClose={resetPage}
    />
  )
}
